<template>
      <b-row align-v="center" align-h="around">
        <b-col cols="9" sm="7" md="5" order-md="2"><img src="../assets/first.svg" alt="Person"></b-col>
        <b-col sm="12" md="6" lg="4" class="py-5">
          <h1 class="mb-4">
            <div v-if="$root.slugData.text" v-html="$root.slugData.text"></div>
            <div v-else>
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
            </div>
          </h1>
          <b-button variant="primary" size="lg" v-on:click="$emit('click', 1)" :disabled="$root.slugData.text == null">Commencer</b-button>
        </b-col>
      </b-row>
</template>

<script>
export default {
  name: "Home"
};

</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
}
</style>
